import { render } from "./AdminAddProduct.vue?vue&type=template&id=b520efb4&scoped=true"
import script from "./AdminAddProduct.vue?vue&type=script&lang=js"
export * from "./AdminAddProduct.vue?vue&type=script&lang=js"

import "./AdminAddProduct.vue?vue&type=style&index=0&id=b520efb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b520efb4"]])

export default __exports__